<div id="summernote" class="summernote">
  <span></span>
</div>